/* ============================================================
   CONVERT — Editorial Commerce Theme
   Vanilla JS, no dependencies. One IIFE.
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Utilities
  ---------------------------------------------------------- */
  var Shopify = window.Shopify || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); };
  }

  function formatMoney(cents) {
    var currency = (Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ----------------------------------------------------------
     HEADER — scroll shadow + mobile menu
  ---------------------------------------------------------- */
  var header = $('[data-header]') || $('.site-header');
  var mobileToggle = $('.mobile-menu-toggle');
  var mobileNav = $('.mobile-nav');

  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', debounce(onScroll, 10), { passive: true });
  }

  var mobileOverlay = $('[data-mobile-nav-overlay]') || $('.mobile-nav-overlay');
  var mobileClose   = $('[data-mobile-nav-close]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    if (mobileOverlay) mobileOverlay.classList.add('open');
    if (mobileToggle) {
      mobileToggle.classList.add('active');
      mobileToggle.setAttribute('aria-expanded', 'true');
    }
    document.body.classList.add('no-scroll');
    /* focus trap entry — first focusable inside the panel */
    var first = mobileNav.querySelector('a, button, select, input');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 80);
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    if (mobileToggle) {
      mobileToggle.classList.remove('active');
      mobileToggle.setAttribute('aria-expanded', 'false');
      mobileToggle.focus({ preventScroll: true });
    }
    document.body.classList.remove('no-scroll');
  }

  if (mobileToggle && mobileNav) {
    on(mobileToggle, 'click', function () {
      if (mobileNav.classList.contains('open')) closeMobileNav(); else openMobileNav();
    });
    if (mobileClose)   on(mobileClose, 'click', closeMobileNav);
    if (mobileOverlay) on(mobileOverlay, 'click', closeMobileNav);

    /* Close on link tap (so navigation feels snappy) */
    $$('.mobile-nav__primary a, .mobile-nav__sub a', mobileNav).forEach(function (a) {
      on(a, 'click', closeMobileNav);
    });

    /* Escape to close */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeMobileNav();
    });
  }

  /* ----------------------------------------------------------
     PRODUCT GALLERY — thumb switching + prev/next arrows + keyboard
     Square 1:1 frame (CSS) — image fills via object-fit: contain.
  ---------------------------------------------------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var mainContainer = $('[data-gallery-main]', gallery);
    var mainImg = mainContainer && mainContainer.querySelector('img');
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var prevBtn = $('[data-gallery-prev]', gallery);
    var nextBtn = $('[data-gallery-next]', gallery);
    var counterEl = $('[data-gallery-counter]', gallery);
    /* Vertical thumbs carousel (desktop): up/down nav + scroll wrap */
    var thumbsCol = $('[data-thumbs-col]', gallery);
    var thumbsList = $('[data-thumbs-list]', gallery);
    var thumbsUp = $('[data-thumbs-up]', gallery);
    var thumbsDown = $('[data-thumbs-down]', gallery);

    if (!mainImg || thumbs.length < 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (counterEl) counterEl.style.display = 'none';
      return;
    }

    var currentIdx = 0;
    var total = thumbs.length;

    thumbs.forEach(function (thumb) {
      var img = new Image();
      img.src = thumb.dataset.galleryThumb;
      if (thumb.dataset.galleryThumbSrcset) img.srcset = thumb.dataset.galleryThumbSrcset;
    });

    if (counterEl) counterEl.textContent = '1 / ' + total;

    /* ---- Sync thumbs column height to main image height (desktop only) ----
       Without this, a long gallery (10+ images) overflows the page below
       the main image. The CSS clips with overflow: hidden + JS scroll. */
    function syncThumbsHeight() {
      if (!thumbsCol || !mainContainer) return;
      if (window.innerWidth < 900) {
        thumbsCol.style.height = '';
      } else {
        thumbsCol.style.height = mainContainer.offsetHeight + 'px';
      }
      updateThumbsArrows();
    }

    /* Detect orientation from viewport — mobile = horizontal strip, desktop = vertical column */
    function isHorizontal() { return window.innerWidth < 900; }

    function updateThumbsArrows() {
      if (!thumbsList || !thumbsUp || !thumbsDown) return;
      var sl, max;
      if (isHorizontal()) {
        sl = thumbsList.scrollLeft;
        max = thumbsList.scrollWidth - thumbsList.clientWidth;
      } else {
        sl = thumbsList.scrollTop;
        max = thumbsList.scrollHeight - thumbsList.clientHeight;
      }
      thumbsUp.disabled = sl <= 2;
      thumbsDown.disabled = sl >= max - 2 || max <= 0;
    }

    function scrollThumbs(dir) {
      if (!thumbsList) return;
      var amount = 240 * dir;
      if (isHorizontal()) {
        thumbsList.scrollBy({ left: amount, behavior: 'smooth' });
      } else {
        thumbsList.scrollBy({ top: amount, behavior: 'smooth' });
      }
    }

    if (thumbsUp)   on(thumbsUp,   'click', function () { scrollThumbs(-1); });
    if (thumbsDown) on(thumbsDown, 'click', function () { scrollThumbs(+1); });
    if (thumbsList) on(thumbsList, 'scroll', updateThumbsArrows);

    /* Sync on init + on image load + on resize */
    if (mainImg.complete) {
      requestAnimationFrame(syncThumbsHeight);
    } else {
      mainImg.addEventListener('load', syncThumbsHeight);
    }
    window.addEventListener('resize', debounce(syncThumbsHeight, 100));

    function activateIndex(idx) {
      idx = ((idx % total) + total) % total;
      currentIdx = idx;
      var thumb = thumbs[idx];
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      mainImg.src = thumb.dataset.galleryThumb;
      mainImg.srcset = thumb.dataset.galleryThumbSrcset || '';
      /* Frame uses height:auto + width:100% on the img — natural size, no JS sync needed */
      if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + total;
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      /* If the main image height changed because of new aspect-ratio, re-sync
         the desktop thumbs column height (otherwise it may not match anymore). */
      if (typeof syncThumbsHeight === 'function') {
        requestAnimationFrame(syncThumbsHeight);
      }
    }

    thumbs.forEach(function (thumb, idx) {
      on(thumb, 'click', function () { activateIndex(idx); });
    });

    if (prevBtn) on(prevBtn, 'click', function () { activateIndex(currentIdx - 1); });
    if (nextBtn) on(nextBtn, 'click', function () { activateIndex(currentIdx + 1); });

    /* Keyboard arrows when the gallery (or any element inside it) has focus */
    on(gallery, 'keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); activateIndex(currentIdx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); activateIndex(currentIdx + 1); }
    });
  });

  /* ----------------------------------------------------------
     VARIANT SELECTOR — proper multi-option lookup
     Reads variant JSON from <script data-product-variants>,
     tracks selected value per option, finds matching variant.
  ---------------------------------------------------------- */
  $$('form[data-add-to-cart]').forEach(function (form) {
    var variantsScript = form.parentElement.querySelector('[data-product-variants]')
                      || document.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id-input]') || form.querySelector('[name="id"]');
    var selectors = $$('[data-variant-selector]', form.parentElement);
    if (!selectors.length) return;

    /* Build current selection from .selected buttons */
    var selection = selectors.map(function (s) {
      var sel = s.querySelector('.variant__opt.selected');
      return sel ? sel.dataset.variantValue : null;
    });

    selectors.forEach(function (s) {
      if (!s.classList.contains('variant--size')) return;
      var sizeOrder = { xxs: 0, xs: 1, s: 2, m: 3, l: 4, xl: 5, xxl: 6, '2xl': 6, xxxl: 7, '3xl': 7, '4xl': 8, '5xl': 9, '6xl': 10 };
      var wrap = s.querySelector('.variant__opts');
      if (!wrap) return;
      $$('.variant__opt', s).sort(function (a, b) {
        var av = String(a.dataset.variantValue || '').toLowerCase().replace(/\s/g, '');
        var bv = String(b.dataset.variantValue || '').toLowerCase().replace(/\s/g, '');
        return (sizeOrder[av] == null ? 99 : sizeOrder[av]) - (sizeOrder[bv] == null ? 99 : sizeOrder[bv]);
      }).forEach(function (opt) { wrap.appendChild(opt); });
    });

    function syncSelectedButtons() {
      selectors.forEach(function (s, i) {
        $$('.variant__opt', s).forEach(function (opt) {
          var selected = opt.dataset.variantValue === selection[i];
          opt.classList.toggle('selected', selected);
          opt.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    }

    function updateOptionAvailability() {
      selectors.forEach(function (s, i) {
        $$('.variant__opt', s).forEach(function (opt) {
          var candidate = opt.dataset.variantValue;
          var available = variants.some(function (variant) {
            if (!variant.available || variant.options[i] !== candidate) return false;
            for (var j = 0; j < i; j++) {
              if (selection[j] != null && variant.options[j] !== selection[j]) return false;
            }
            return true;
          });
          opt.disabled = !available;
        });
      });
    }

    function ensureAvailableSelection(changedIndex) {
      var exact = findVariant();
      if (exact && exact.available) return;
      var fallback = variants.find(function (variant) {
        if (!variant.available) return false;
        for (var i = 0; i <= changedIndex; i++) {
          if (selection[i] != null && variant.options[i] !== selection[i]) return false;
        }
        return true;
      });
      if (!fallback) return;
      for (var j = changedIndex + 1; j < selection.length; j++) selection[j] = fallback.options[j];
      syncSelectedButtons();
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selection[i] == null || opt === selection[i];
        });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;

      /* Update price displays */
      var priceEls = $$('[data-product-price]');
      var compareEls = $$('[data-product-compare-price]');
      var urgencyEls = $$('[data-product-urgency]');

      priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
      compareEls.forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          el.textContent = formatMoney(v.compare_at_price);
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });

      /* Genuine low-stock messaging follows the selected variant. */
      urgencyEls.forEach(function (el) {
        var threshold = parseInt(el.dataset.threshold, 10) || 0;
        var qty = parseInt(v.inventory_quantity, 10) || 0;
        var isLow = Boolean(v.inventory_management) && qty > 0 && qty < threshold;
        el.hidden = !isLow;
        if (isLow) {
          var textEl = el.querySelector('[data-product-urgency-text]');
          var tpl = el.dataset.template || 'Only __COUNT__ left';
          if (textEl) textEl.textContent = tpl.replace('__COUNT__', qty);
        }
      });

      /* Update label (e.g. "Size: Medium") */
      selectors.forEach(function (s, i) {
        var label = s.querySelector('[data-variant-label]');
        if (label) label.textContent = selection[i] || '';
      });
      var selectionSummary = form.querySelector('[data-product-selection]');
      if (selectionSummary) selectionSummary.textContent = selection.filter(Boolean).join(' / ');
      updateOptionAvailability();

      var colorSelector = selectors.find(function (selector) {
        return selector.classList.contains('variant--color');
      });
      var selectedColor = colorSelector && colorSelector.querySelector('.variant__opt.selected');
      var mediaThumb = null;
      if (selectedColor && selectedColor.dataset.galleryIndex != null) {
        var galleryThumbs = $$('[data-gallery-thumb]');
        mediaThumb = galleryThumbs[parseInt(selectedColor.dataset.galleryIndex, 10)];
      }
      if (!mediaThumb && v.featured_image_id) {
        mediaThumb = document.querySelector('[data-gallery-thumb][data-media-id="' + v.featured_image_id + '"]');
      }
      if (mediaThumb && !mediaThumb.classList.contains('active')) mediaThumb.click();

      /* Update buy button availability — uses translated templates from form data attrs */
      var buyBtn = form.querySelector('.btn--buy');
      var btnText = buyBtn && buyBtn.querySelector('.btn-text');
      if (buyBtn) {
        if (v.available) {
          buyBtn.removeAttribute('disabled');
          if (btnText) btnText.textContent = form.dataset.i18nAddToCart || 'Add to cart';
        } else {
          buyBtn.setAttribute('disabled', '');
          if (btnText) btnText.textContent = form.dataset.i18nSoldOut || 'Sold out';
        }
      }

      var stickyBuyBtn = document.querySelector('[data-sticky-buy]');
      if (stickyBuyBtn) {
        var stickyText = stickyBuyBtn.querySelector('.btn-text');
        stickyBuyBtn.disabled = !v.available;
        if (stickyText) stickyText.textContent = v.available
          ? (form.dataset.i18nAddToCartLabel || 'Add to cart')
          : (form.dataset.i18nSoldOut || 'Sold out');
      }
    }

    /* Wire option clicks */
    selectors.forEach(function (s, i) {
      var opts = $$('.variant__opt', s);
      opts.forEach(function (opt) {
        on(opt, 'click', function () {
          if (opt.disabled) return;
          selection[i] = opt.dataset.variantValue;
          syncSelectedButtons();
          ensureAvailableSelection(i);
          update();
        });
      });

    });

    /* Initial sync (in case Liquid + JS think differently) */
    update();
  });

  /* ----------------------------------------------------------
     QUANTITY SELECTOR (.qty)
  ---------------------------------------------------------- */
  $$('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    var minus = q.querySelector('[data-qty-minus]');
    var plus  = q.querySelector('[data-qty-plus]');
    if (minus) on(minus, 'click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > parseInt(input.min || '1', 10)) input.value = v - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) on(plus, 'click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ----------------------------------------------------------
     ADD TO CART — AJAX + open drawer
  ---------------------------------------------------------- */
  $$('form[data-add-to-cart]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.btn--buy');
      if (!btn || btn.classList.contains('loading') || btn.hasAttribute('disabled')) return;

      btn.classList.add('loading');

      var fd = new FormData(form);
      var data = {
        items: [{
          id: fd.get('id'),
          quantity: parseInt(fd.get('quantity'), 10) || 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return r.json();
        })
        .then(function () {
          btn.classList.remove('loading');
          btn.classList.add('btn--added');
          var txt = btn.querySelector('.btn-text');
          var orig = txt ? txt.innerHTML : '';
          if (txt) txt.textContent = form.dataset.i18nAdded || 'Added';

          fetchCart().then(function (cart) {
            renderCart(cart);
            updateCartCount(cart.item_count);
            openCartDrawer();
          });

          setTimeout(function () {
            btn.classList.remove('btn--added');
            if (txt) txt.innerHTML = orig;
          }, 2000);
        })
        .catch(function (err) {
          btn.classList.remove('loading');
          console.error(err);
          alert(form.dataset.i18nError || 'Something went wrong. Please try again.');
        });
    });
  });

  /* ----------------------------------------------------------
     CART DRAWER
  ---------------------------------------------------------- */
  var cartOverlay = $('[data-cart-overlay]') || $('.cart-overlay');
  var cartDrawer  = $('[data-cart-drawer]')  || $('.cart-drawer');
  var cartClose   = $('.cart-drawer__close');
  var cartToggles = $$('.cart-toggle');

  function openCartDrawer() {
    if (!cartOverlay || !cartDrawer) return;
    cartOverlay.classList.add('open');
    cartDrawer.classList.add('open');
    document.body.classList.add('no-scroll');
    document.body.classList.add('cart-open');
    cartOverlay.setAttribute('aria-hidden', 'false');
  }
  function closeCartDrawer() {
    if (!cartOverlay || !cartDrawer) return;
    cartOverlay.classList.remove('open');
    cartDrawer.classList.remove('open');
    document.body.classList.remove('no-scroll');
    document.body.classList.remove('cart-open');
    cartOverlay.setAttribute('aria-hidden', 'true');
  }

  cartToggles.forEach(function (t) {
    on(t, 'click', function (e) {
      e.preventDefault();
      openCartDrawer();
      fetchCart().then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      }).catch(function () {});
    });
  });
  if (cartClose) on(cartClose, 'click', closeCartDrawer);
  if (cartOverlay) on(cartOverlay, 'click', closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('visible', count > 0);
    });
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function renderCart(cart) {
    if (!cartDrawer) return;
    var itemsEl  = cartDrawer.querySelector('[data-cart-items]') || cartDrawer.querySelector('.cart-drawer__items');
    var totalEl  = cartDrawer.querySelector('[data-cart-total]') || cartDrawer.querySelector('.cart-drawer__total-price');
    var footerEl = cartDrawer.querySelector('[data-cart-footer]');

    /* Pull translated strings from data-* attrs on the drawer (set by Liquid).
       Fallback to English if the attrs are missing for some reason. */
    var t = {
      empty:   cartDrawer.dataset.emptyText    || 'Your cart is empty',
      cta:     cartDrawer.dataset.emptyCta     || 'Continue shopping',
      remove:  cartDrawer.dataset.removeLabel  || 'Remove',
      qtyDec:  cartDrawer.dataset.qtyDecrease  || 'Decrease quantity',
      qtyInc:  cartDrawer.dataset.qtyIncrease  || 'Increase quantity'
    };

    if (!itemsEl) return;

    /* Empty state */
    if (cart.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>' + escapeHtml(t.empty) + '</p>' +
          '<a href="/collections/all" class="btn btn--secondary">' + escapeHtml(t.cta) + '</a>' +
        '</div>';
      if (footerEl) footerEl.setAttribute('hidden', '');
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }

    if (footerEl) footerEl.removeAttribute('hidden');

    /* Items */
    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<a href="' + item.url + '"><img src="' + Shopify.imageSize(item.image, '240x') + '" alt="' + escapeHtml(item.product_title) + '" width="96" height="112" loading="lazy"></a>'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title.replace(/ \/ /g, ' · ')) + '</div>'
        : '';
      return '' +
        '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__image">' + img + '</div>' +
          '<div class="cart-item__details">' +
            '<div class="cart-item__info">' +
              '<a href="' + item.url + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
              variant +
              '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>' +
            '<div class="cart-item__actions">' +
              '<div class="cart-item__qty">' +
                '<button type="button" data-cart-qty="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + escapeHtml(t.qtyDec) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-cart-qty="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + escapeHtml(t.qtyInc) + '">+</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-cart-remove="' + item.key + '" aria-label="' + escapeHtml(t.remove + ' — ' + item.product_title) + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                '<span>' + escapeHtml(t.remove) + '</span>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');

    itemsEl.innerHTML = html;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    /* Re-bind item buttons */
    $$('[data-cart-qty]', itemsEl).forEach(function (btn) {
      on(btn, 'click', function () { changeCartItem(btn.dataset.cartQty, parseInt(btn.dataset.qty, 10)); });
    });
    $$('[data-cart-remove]', itemsEl).forEach(function (btn) {
      on(btn, 'click', function () { changeCartItem(btn.dataset.cartRemove, 0); });
    });
  }

  /* Shopify.imageSize fallback (defensive — rarely needed in modern themes) */
  if (!Shopify.imageSize) {
    Shopify.imageSize = function (src, size) {
      if (!src) return '';
      return src.replace(/\.(jpg|jpeg|gif|png|bmp|webp)(\?.*)?$/i, '_' + size + '.$1$2');
    };
  }

  function changeCartItem(key, qty) {
    var changingItem = cartDrawer && cartDrawer.querySelector('[data-key="' + CSS.escape(key) + '"]');
    if (changingItem) changingItem.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {
        if (changingItem) changingItem.classList.remove('is-updating');
      });
  }

  /* Initial cart count sync */
  fetchCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});

  /* ----------------------------------------------------------
     STICKY ADD TO CART (mobile, PDP)
  ---------------------------------------------------------- */
  var stickyATC = $('[data-sticky-atc]') || $('.sticky-atc');
  var pdpForm = $('form[data-add-to-cart]');

  if (stickyATC && pdpForm && 'IntersectionObserver' in window) {
    var headerOffset = (header && header.offsetHeight) || 64;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var hasPassedForm = e.boundingClientRect.top < headerOffset;
        stickyATC.classList.toggle('visible', !e.isIntersecting && hasPassedForm);
      });
    }, { rootMargin: '-' + headerOffset + 'px 0px 0px 0px', threshold: 0 });
    io.observe(pdpForm);

    var stickyBuy = stickyATC.querySelector('[data-sticky-buy]') || stickyATC.querySelector('.btn--buy');
    if (stickyBuy) on(stickyBuy, 'click', function (e) {
      e.preventDefault();
      var mainBtn = pdpForm.querySelector('.btn--buy');
      if (mainBtn) mainBtn.click();
      else pdpForm.requestSubmit();
    });
  }

  /* ----------------------------------------------------------
     FAQ ACCORDION
  ---------------------------------------------------------- */
  $$('.faq-item__q').forEach(function (q) {
    on(q, 'click', function () {
      var item = q.closest('.faq-item');
      if (!item) return;
      var wasOpen = item.classList.contains('open');
      var siblings = item.parentElement.querySelectorAll('.faq-item');
      siblings.forEach(function (s) {
        s.classList.remove('open');
        var sb = s.querySelector('.faq-item__q');
        if (sb) sb.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ----------------------------------------------------------
     WISHLIST — store full product objects (id, handle, title,
     image, url, price, variantId) in localStorage so the cart
     drawer's wishlist tab can render without an API roundtrip.
  ---------------------------------------------------------- */
  var WISHLIST_KEY = 'convert_wishlist_v1';

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      // Backwards-compat: old format was array of string IDs only.
      // Migrate to object format on first read; objects without metadata
      // will get filled in next time the user toggles them on a card.
      return raw.map(function (entry) {
        return typeof entry === 'string' ? { id: entry } : entry;
      });
    } catch (e) { return []; }
  }
  function setWishlist(items) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); } catch (e) {}
    updateWishlistCount();
    if (cartDrawer && cartDrawer.querySelector('[data-cart-panel="wishlist"].is-active')) {
      renderWishlistPanel();
    }
  }
  function getWishlistIds() { return getWishlist().map(function (i) { return String(i.id); }); }

  function syncWishlistButtons() {
    var ids = getWishlistIds();
    $$('[data-wishlist]').forEach(function (btn) {
      var id = String(btn.dataset.productId);
      var active = ids.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateWishlistCount() {
    var n = getWishlist().length;
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = n; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = String(btn.dataset.productId || '');
    if (!id) return;
    var items = getWishlist();
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === id) { idx = i; break; }
    }
    if (idx === -1) {
      items.push({
        id: id,
        handle: btn.dataset.productHandle || '',
        title: btn.dataset.productTitle || '',
        url: btn.dataset.productUrl || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || '',
        variantId: btn.dataset.productVariantId || '',
        available: btn.dataset.productAvailable !== '0'
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      items.splice(idx, 1);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    }
    setWishlist(items);
  });

  /* ----------------------------------------------------------
     CART DRAWER — TAB SWITCHING (Cart vs Wishlist)
  ---------------------------------------------------------- */
  function escAttr(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
  }); }

  function switchCartTab(tabName) {
    if (!cartDrawer) return;
    var tabs = $$('[data-cart-tab]', cartDrawer);
    tabs.forEach(function (t) {
      var on = t.dataset.cartTab === tabName;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var panels = $$('[data-cart-panel]', cartDrawer);
    panels.forEach(function (p) {
      var on = p.dataset.cartPanel === tabName;
      p.classList.toggle('is-active', on);
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
    if (tabName === 'wishlist') renderWishlistPanel();
  }

  function renderWishlistPanel() {
    var host = document.querySelector('[data-wishlist-items]');
    if (!host) return;
    var items = getWishlist();
    if (!items.length) {
      var emptyText = cartDrawer && cartDrawer.dataset.wishlistEmptyText || 'Wishlist is empty';
      var ctaText   = cartDrawer && cartDrawer.dataset.wishlistEmptyCta  || 'Discover';
      host.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<p>' + escAttr(emptyText) + '</p>' +
          '<a href="/collections/all" class="btn btn--secondary">' + escAttr(ctaText) + '</a>' +
        '</div>';
      return;
    }
    var moveLabel = cartDrawer && cartDrawer.dataset.moveToCartText || 'Add to cart';
    var removeLabel = cartDrawer && cartDrawer.dataset.removeLabel || 'Remove';
    host.innerHTML = items.map(function (it) {
      var img = it.image
        ? '<img src="' + escAttr(it.image) + '" alt="' + escAttr(it.title) + '" loading="lazy">'
        : '<div class="wish-item__img-placeholder" aria-hidden="true"></div>';
      var available = it.available !== false && it.variantId;
      var moveBtn = available
        ? ('<button type="button" class="wish-item__add" data-wishlist-move="' + escAttr(it.variantId) + '" data-wishlist-id="' + escAttr(it.id) + '">' +
             '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
               '<path d="M5 12h14M12 5v14" stroke-linecap="round"/>' +
             '</svg>' +
             '<span>' + escAttr(moveLabel) + '</span>' +
           '</button>')
        : '<span class="wish-item__unavailable">' + escAttr(cartDrawer.dataset.unavailableText || 'Unavailable') + '</span>';
      return (
        '<article class="wish-item" data-wishlist-key="' + escAttr(it.id) + '">' +
          '<a class="wish-item__media" href="' + escAttr(it.url) + '" aria-label="' + escAttr(it.title) + '">' +
            img +
          '</a>' +
          '<div class="wish-item__body">' +
            '<a href="' + escAttr(it.url) + '" class="wish-item__title">' + escAttr(it.title) + '</a>' +
            (it.price ? '<div class="wish-item__price">' + escAttr(it.price) + '</div>' : '') +
            '<div class="wish-item__actions">' + moveBtn + '</div>' +
          '</div>' +
          '<button type="button" class="wish-item__remove" data-wishlist-remove="' + escAttr(it.id) + '" aria-label="' + escAttr(removeLabel) + '">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
              '<path d="M6 6l12 12M6 18L18 6" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('[data-cart-tab]');
    if (tabBtn) { e.preventDefault(); switchCartTab(tabBtn.dataset.cartTab); return; }

    var rmBtn = e.target.closest('[data-wishlist-remove]');
    if (rmBtn) {
      e.preventDefault();
      var id = String(rmBtn.dataset.wishlistRemove);
      var list = getWishlist().filter(function (i) { return String(i.id) !== id; });
      setWishlist(list);
      syncWishlistButtons();
      return;
    }

    var moveBtn = e.target.closest('[data-wishlist-move]');
    if (moveBtn) {
      e.preventDefault();
      var variantId = moveBtn.dataset.wishlistMove;
      var wishId = String(moveBtn.dataset.wishlistId || '');
      if (!variantId) return;
      moveBtn.disabled = true;
      moveBtn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        // Remove from wishlist after successful add
        if (wishId) {
          var rest = getWishlist().filter(function (i) { return String(i.id) !== wishId; });
          setWishlist(rest);
          syncWishlistButtons();
        }
        // Refresh cart, re-render the drawer items, then switch to cart tab
        if (typeof fetchCart === 'function' && typeof renderCart === 'function') {
          fetchCart().then(function (cart) {
            renderCart(cart);
            updateCartCount(cart.item_count);
            switchCartTab('cart');
          });
        } else {
          switchCartTab('cart');
        }
      }).catch(function () {
        moveBtn.disabled = false;
        moveBtn.textContent = cartDrawer.dataset.moveToCartText || 'Add to cart';
      });
    }
  });

  syncWishlistButtons();
  updateWishlistCount();

  /* ----------------------------------------------------------
     COLLECTION CATEGORY FILTER — client-side, by product tag
     Pills carry data-filter (tag, or "*" for all). Cards carry
     data-product-categories (comma-joined tags). Filtering toggles
     card display and updates the product count + empty state.
  ---------------------------------------------------------- */
  var collFilter = $('[data-collection-filter]');
  var collSelect = $('[data-collection-filter-select]');
  if (collFilter || collSelect) {
    var collGrid = $('[data-collection-grid]');
    var collEmpty = $('[data-collection-filter-empty]');
    var collCount = $('[data-collection-count]');
    var collCards = collGrid ? $$('.product-card', collGrid) : [];

    var setCount = function (n) {
      if (!collCount) return;
      var tpl = (n === 1 ? collCount.dataset.countOne : collCount.dataset.countOther) || '';
      collCount.textContent = tpl.replace('%%', n);
    };

    /* Apply a category filter and keep the pill row + mobile select in sync */
    var applyCollFilter = function (cat) {
      if (collFilter) {
        $$('[data-filter]', collFilter).forEach(function (p) {
          var active = p.dataset.filter === cat;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
      if (collSelect && collSelect.value !== cat) collSelect.value = cat;

      var visible = 0;
      collCards.forEach(function (card) {
        var cats = (card.getAttribute('data-product-categories') || '').split(',');
        var show = cat === '*' || cats.indexOf(cat) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (collEmpty) { if (visible === 0) { collEmpty.removeAttribute('hidden'); } else { collEmpty.setAttribute('hidden', ''); } }
      setCount(visible);
    };

    if (collFilter) {
      on(collFilter, 'click', function (e) {
        var pill = e.target.closest('[data-filter]');
        if (!pill) return;
        applyCollFilter(pill.dataset.filter);
      });
    }
    if (collSelect) {
      on(collSelect, 'change', function () { applyCollFilter(collSelect.value); });
    }
  }

  /* ----------------------------------------------------------
     SCROLL REVEAL — staggered fade-up
  ---------------------------------------------------------- */
  var revealEls = $$('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          /* Stagger siblings within the same parent */
          var siblings = $$('.reveal:not(.visible)', e.target.parentElement);
          var delay = siblings.indexOf(e.target);
          if (delay >= 0 && delay < 6) {
            e.target.style.transitionDelay = (delay * 60) + 'ms';
          }
          e.target.classList.add('visible');
          revealIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { revealIO.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ============================================================
     PROMO MODAL — show on first visit of the week + countdown to next reset
     ============================================================ */
  var promoModal = $('[data-promo-modal]');
  if (promoModal) {
    var resetDay = parseInt(promoModal.dataset.resetDay, 10);
    if (isNaN(resetDay)) resetDay = 1; // Monday by default
    var showDelay = parseInt(promoModal.dataset.showDelay, 10) || 1500;

    function nextReset() {
      var now = new Date();
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
      var add = (resetDay - d.getDay() + 7) % 7;
      if (add === 0) add = 7;
      d.setDate(d.getDate() + add);
      return d.getTime();
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    var timerEls = {
      d: promoModal.querySelector('[data-timer-d]'),
      h: promoModal.querySelector('[data-timer-h]'),
      m: promoModal.querySelector('[data-timer-m]'),
      s: promoModal.querySelector('[data-timer-s]')
    };
    var endTs = nextReset();

    function tick() {
      var diff = Math.max(0, endTs - Date.now());
      var sec = Math.floor(diff / 1000);
      var d = Math.floor(sec / 86400);
      var h = Math.floor((sec % 86400) / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var s = sec % 60;
      if (timerEls.d) timerEls.d.textContent = pad(d);
      if (timerEls.h) timerEls.h.textContent = pad(h);
      if (timerEls.m) timerEls.m.textContent = pad(m);
      if (timerEls.s) timerEls.s.textContent = pad(s);
      if (diff <= 0) endTs = nextReset();
    }

    var STORAGE_KEY = 'promo_modal_dismissed_until';
    var COOLDOWN_MS = 2 * 24 * 60 * 60 * 1000; // 2 days
    function shouldShow() {
      try {
        var until = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        return !until || isNaN(until) || Date.now() > until;
      } catch (_) { return true; }
    }
    function markDismissed() {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now() + COOLDOWN_MS)); } catch (_) {}
    }

    function openModal() {
      promoModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      tick();
      promoModal._timerId = setInterval(tick, 1000);
    }
    function closeModal() {
      promoModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      if (promoModal._timerId) clearInterval(promoModal._timerId);
      markDismissed();
    }

    $$('[data-promo-close]', promoModal).forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && promoModal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    if (shouldShow()) {
      setTimeout(openModal, showDelay);
    }
  }

  /* ============================================================
     LOOKBOOK CAROUSEL — infinite loop (clone-and-teleport pattern)
     Clones the original slides at the head and tail of the track,
     then silently jumps scrollLeft when the user crosses into a clone
     zone — the loop feels seamless in both directions.
     ============================================================ */
  $$('[data-lookbook]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-lookbook-track]');
    if (!track) return;
    var section = carousel.closest('.lookbook') || carousel.parentElement;
    var prevBtn = section.querySelector('[data-lookbook-prev]');
    var nextBtn = section.querySelector('[data-lookbook-next]');
    var progressBar = section.querySelector('[data-lookbook-progress-bar]');

    var originalSlides = $$('.lookbook__slide', track);
    if (!originalSlides.length) return;

    /* Set video aspect-ratio after metadata loads (intrinsic sizing for autoplaying videos
       so the tile width matches the actual video — no crop, no letterbox). */
    function bindVideoSizing(scope) {
      $$('.lookbook__slide-video', scope || track).forEach(function (v) {
        if (v._sizingBound) return;
        v._sizingBound = true;
        var setRatio = function () {
          if (v.videoWidth && v.videoHeight) {
            v.style.aspectRatio = v.videoWidth + ' / ' + v.videoHeight;
            requestAnimationFrame(measure);
          }
        };
        if (v.readyState >= 1) setRatio();
        else v.addEventListener('loadedmetadata', setRatio, { once: true });
      });
    }

    /* Clone slides at start and end. Total: 3× originals → seamless infinite loop. */
    var headClones = originalSlides.map(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.dataset.lookbookClone = 'head';
      return c;
    });
    var tailClones = originalSlides.map(function (s) {
      var c = s.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.dataset.lookbookClone = 'tail';
      return c;
    });
    /* Prepend in reverse so display order is preserved */
    headClones.slice().reverse().forEach(function (c) { track.insertBefore(c, track.firstChild); });
    tailClones.forEach(function (c) { track.appendChild(c); });

    bindVideoSizing();

    var headWidth = 0;
    var originalsWidth = 0;
    var gap = 0;

    function measure() {
      var styles = window.getComputedStyle(track);
      gap = parseFloat(styles.gap) || 16;
      var slides = $$('.lookbook__slide', track);
      var n = originalSlides.length;
      headWidth = 0;
      for (var i = 0; i < n; i++) headWidth += slides[i].offsetWidth + gap;
      originalsWidth = 0;
      for (var j = n; j < n * 2; j++) originalsWidth += slides[j].offsetWidth + gap;
    }

    function jumpTo(left) {
      track.classList.add('is-jumping');
      track.scrollLeft = left;
      // Force reflow so the next scroll event reads the new position
      void track.offsetWidth;
      track.classList.remove('is-jumping');
    }

    /* Modulo-based recenter: handles arbitrary overshoot in either direction
       (multi-cycle scrolls from rapid button clicks land cleanly back inside
       the originals zone, not just at the immediate boundary). */
    function recenter() {
      if (originalsWidth <= 0) return;
      var relative = track.scrollLeft - headWidth;
      if (relative >= 0 && relative < originalsWidth) return;
      var newRel = ((relative % originalsWidth) + originalsWidth) % originalsWidth;
      jumpTo(headWidth + newRel);
    }

    function tileWidth() {
      var first = track.querySelector('.lookbook__slide');
      if (!first) return 320;
      return first.getBoundingClientRect().width + gap;
    }

    function updateProgress() {
      if (!progressBar || originalsWidth <= 0) return;
      var pos = ((track.scrollLeft - headWidth) % originalsWidth + originalsWidth) % originalsWidth;
      var pct = pos / originalsWidth;
      var visiblePct = Math.max(8, Math.min(60, (track.clientWidth / originalsWidth) * 100));
      progressBar.style.width = visiblePct + '%';
      progressBar.style.transform = 'translateX(' + ((100 - visiblePct) * pct) + '%)';
    }

    function init() {
      measure();
      jumpTo(headWidth);
      updateProgress();
    }

    /* Pre-emptive recenter on button clicks: if we're already past the safe
       zone, jump back into it BEFORE starting the smooth scroll. This way the
       browser's smooth-scroll animation runs entirely inside safe territory
       and is never interrupted mid-flight by a teleport (which is what caused
       the visible "stop and resume" stutter). */
    function safeStep(direction) {
      recenter();
      track.scrollBy({ left: direction * tileWidth(), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.disabled = false;
      prevBtn.addEventListener('click', function () { safeStep(-1); });
    }
    if (nextBtn) {
      nextBtn.disabled = false;
      nextBtn.addEventListener('click', function () { safeStep(1); });
    }

    /* SCROLL events feed the progress bar only — fast, fires constantly. */
    var progressTicking = false;
    track.addEventListener('scroll', function () {
      if (progressTicking) return;
      progressTicking = true;
      requestAnimationFrame(function () {
        updateProgress();
        progressTicking = false;
      });
    }, { passive: true });

    /* SCROLLEND event drives the teleport — fires ONCE when scrolling fully
       settles. Teleporting now is invisible because no animation is in flight
       to be interrupted. Falls back to a 140 ms scroll-quiet timer for older
       browsers (Safari < 18.2). */
    var scrollEndTimer = null;
    function handleScrollEnd() { recenter(); updateProgress(); }

    if ('onscrollend' in document.documentElement) {
      track.addEventListener('scrollend', handleScrollEnd);
    } else {
      track.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(handleScrollEnd, 140);
      }, { passive: true });
    }

    window.addEventListener('resize', debounce(function () {
      var ratio = originalsWidth > 0 ? (track.scrollLeft - headWidth) / originalsWidth : 0;
      measure();
      jumpTo(headWidth + ratio * originalsWidth);
      updateProgress();
    }, 150));

    if (document.readyState === 'complete') requestAnimationFrame(init);
    else window.addEventListener('load', init, { once: true });
  });

  /* ============================================================
     IMAGE WATERMARK — bakes "araibikejackets.fr" into the hero +
     lookbook images via <canvas>, so a right-click-saved / downloaded
     copy carries the mark (not just a CSS overlay that can be bypassed).
     A separate crossOrigin loader is used (Shopify's CDN returns CORS
     headers) so the visible <img> is never at risk if CORS ever fails —
     in that case the original simply stays untouched. Results are cached
     by source URL so the carousel's cloned slides reuse the same render.
     ============================================================ */
  (function () {
    if (!('toBlob' in document.createElement('canvas'))) return;
    var WM_TEXT = 'araibikejackets.fr';
    var cache = {};

    function render(srcImg) {
      var w = srcImg.naturalWidth, h = srcImg.naturalHeight;
      if (!w || !h) return null;
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(srcImg, 0, 0, w, h);

      var fs = Math.max(Math.round(w / 32), 12);
      ctx.font = '600 ' + fs + 'px "Inter Tight", system-ui, sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = 'rgba(255,255,255,0.06)';

      var diag = Math.sqrt(w * w + h * h);
      var stepX = ctx.measureText(WM_TEXT).width + fs * 7;
      var stepY = fs * 8;

      ctx.translate(w / 2, h / 2);
      ctx.rotate(-Math.atan2(h, w));
      var row = 0;
      for (var y = -diag; y < diag; y += stepY) {
        var offset = (row % 2) * (stepX / 2);
        for (var x = -diag; x < diag; x += stepX) {
          ctx.fillText(WM_TEXT, x + offset, y);
        }
        row++;
      }
      return canvas;
    }

    function swap(img, url) {
      img.removeAttribute('srcset');
      img.src = url;
    }

    function apply(img) {
      if (img.dataset.wmDone || img.tagName !== 'IMG') return;
      var src = img.currentSrc || img.src;
      if (!src || src.indexOf('blob:') === 0 || src.indexOf('data:') === 0) return;
      img.dataset.wmDone = '1';
      if (cache[src]) { swap(img, cache[src]); return; }

      var loader = new Image();
      loader.crossOrigin = 'anonymous';
      loader.onload = function () {
        try {
          var canvas = render(loader);
          if (!canvas) return;
          canvas.toBlob(function (blob) {
            if (!blob) return;
            var url = URL.createObjectURL(blob);
            cache[src] = url;
            swap(img, url);
          }, 'image/jpeg', 0.86);
        } catch (e) { /* tainted canvas — keep the original image */ }
      };
      loader.onerror = function () { /* CORS/load failure — keep the original */ };
      loader.src = src;
    }

    /* Defer the (costly) canvas work off the critical load path: only
       watermark an image once it's about to enter the viewport, and run the
       draw during idle time. The hero is intentionally NOT marked (it's the
       LCP element — kept untouched for speed). */
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb(); }, 200); };
    var targets = $$('[data-watermark]');
    if (!targets.length) return;

    function queue(img) {
      if (img.dataset.wmQueued) return;
      img.dataset.wmQueued = '1';
      idle(function () { apply(img); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { io.unobserve(e.target); queue(e.target); }
        });
      }, { rootMargin: '300px' });
      targets.forEach(function (img) { io.observe(img); });
    } else {
      targets.forEach(queue);
    }

    /* Deter casual saving: block right-click menu + drag on these images. */
    targets.forEach(function (img) {
      img.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  })();

})();
